import {
  commonSuggest
} from "./chunk-26UMDPK3.js";
import {
  createSessionToken
} from "./chunk-26L2DNU7.js";
import {
  getConfigWithMetadata
} from "./chunk-NFLWKIRZ.js";
import {
  getErrorResult
} from "./chunk-IPNO7PON.js";
import {
  PlaceType
} from "./chunk-VXLCCQ5A.js";

// src/services/getPlaceSuggestions/getPlaceSuggestions.ts
async function getPlaceSuggestions(query, options, apiConfig) {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, "getPlaceSuggestions");
    const suggestPayload = {
      ...options,
      sessionToken: options.sessionToken ?? createSessionToken(),
      input: query,
      limit: options.limit ?? 10,
      types: options.types ?? [
        PlaceType.country,
        PlaceType.neighborhood,
        PlaceType.locality,
        PlaceType.administrative_area_level_1,
        PlaceType.administrative_area_level_4,
        PlaceType.postal_code,
        PlaceType.sublocality
      ],
      filterCustomPlaceTypes: options.filterCustomPlaceTypes ?? false
    };
    const results = await commonSuggest(suggestPayload, _apiConfig);
    return {
      status: "success",
      data: results
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}

export {
  getPlaceSuggestions
};
